import { useEffect, useState } from 'react';
import ContentService from '../../services/ContentService';
import DeploymentOptions from '../../types/DeploymentOptions';

export default function useContentDeployWizard() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    const [deploymentOptions, setDeploymentOptions] = useState<
        DeploymentOptions | undefined
    >(undefined);

    const load = async () => {
        if (deploymentOptions) {
            // this is some sort of caching for the content api. Data form the content api will not change
            // so we only fetch once. After that, we return the previous values (cache)
            return;
        }

        try {
            const result = await ContentService.getDeploymentWizardOptions();
            setDeploymentOptions(new DeploymentOptions(result));
            setLoading(false);
            setError(null);
        } catch (e: any) {
            setLoading(false);
            setError(e);
        }
    };

    const refresh = () => {
        load();
    };

    useEffect(() => {
        refresh();
    }, []);

    return { deploymentOptions, refresh, loading, error };
}
